;(function($){

    function Likes()
    {
        $("[id*=like-]").on("click", function(e){
            e.preventDefault();

            $(this).attr('disabled', true);

            var btn =  this;
            
            $.get($("#app_url").val() + "/api/depoimentos/like/" + $(btn).data('id'), function( data ) {
                $("#total-" + $(btn).data('id')).html(data.likes);
                $(btn).attr('disabled', false);
            });
        });
    }

   	new Likes();

}(jQuery));
 
 
 
 
